import { booleanize } from '../utilities';
import { AdminApiService } from '../services';
import type { ContactStateResponse } from '../services';
import type { ContactCreate, ContactUpdate } from '../services';

export type GetContactsFilters = {
  search?: string | null;
  campaignId?: string | null;
  latest_contact_state?: string | null;
  requiresHumanInput?: BooleanString;
};

export const getAllContacts = () => {
  return AdminApiService.getContactsApiAdminContactsGet(
    undefined,
    undefined,
    undefined,
    undefined,
    1_000,
    undefined
  );
};

export const getContacts = (
  filters: GetContactsFilters,
  page: ApiPaginationType
) => {
  return AdminApiService.getContactsApiAdminContactsGet(
    undefined,
    undefined,
    filters?.campaignId,
    booleanize(filters.requiresHumanInput),
    page?.limit,
    page?.offset
  );
};

export const getContact = (id: string) => {
  return AdminApiService.getContactApiAdminContactsContactIdGet(id);
};

export const getContactState = (contactId: string) => {
  return AdminApiService.getContactStateApiAdminContactsContactIdStateGet(
    contactId
  );
};

export const addContact = (payload: ContactCreate) => {
  return AdminApiService.createContactApiAdminContactsPost(payload);
};
export const updateContact = (id: string, payload: ContactUpdate) => {
  return AdminApiService.updateContactApiAdminContactsContactIdPatch(
    id,
    payload
  );
};
export const deleteContact = (id: string) => {
  return AdminApiService.deleteContactApiAdminContactsContactIdDelete(id);
};
export const startCampaignForContact = (payload: StartCampaignForContact) => {
  return AdminApiService.startCampaignAdminApiAdminCampaignsStartPost(payload);
};
export const wipeContact = (id: string) => {
  return AdminApiService.cleanContactDataApiAdminContactsContactIdCleanPost(id);
};

export type { ContactResponse as ContactItem } from '../services';
export type ContactCreatePayload = ContactCreate;
export type ContactUpdatePayload = ContactUpdate;
export type ContactStateType = ContactStateResponse;
export type StartCampaignForContact = {
  campaign_strategy: string;
  contact_id: string;
  user_email: string;
};
